export default "__VITE_ASSET__z4Qzzngg__"